export const getNodeForRender = node => {
  const state = node.state || { children: []};
  return {
    ...node,
    state: {
      ...state,
      expanded: state.expanded,
      hasChildren:
        node.hasChildren || state.children.length || state.hasMoreChildren || !state.loaded
    }
  };
};

export const updateNode = (originalNode, newState) => {
  const error = newState.error || false;
  return {
    ...originalNode,
    state: {
      ...originalNode.state,
      ...newState,
      error
    }
  };
};

export const updateNodeInTree = (nodes, updatedNode) => {
  const { parents } = updatedNode;

  if (!parents || !parents.length) {
    return nodes.map(n => (n.id === updatedNode.id ? updatedNode : n));
  }
  const parentIndex = nodes.findIndex(n => n.id === parents[0].id);
  const preSiblings = nodes.slice(0, parentIndex);
  const postSiblings = nodes.slice(parentIndex + 1);
  const parentNode = nodes[parentIndex];
  return [
    ...preSiblings,
    {
      ...parentNode,
      state: {
        ...parentNode.state,
        children: updateNodeInTree(parentNode.state.children, {
          ...updatedNode,
          parents: parents.slice(1)
        })
      }
    },
    ...postSiblings
  ];
};

export const transformNode = (node, selectedNodesOrNodeIds, toggleAncestors, selectedNodes) => {
  const selected = Array.isArray(selectedNodesOrNodeIds)
    ? selectedNodesOrNodeIds.includes(node.id)
    : node.id === selectedNodesOrNodeIds;
  const children = (node.children || []).map(n =>
    transformNode(n, selectedNodesOrNodeIds, toggleAncestors, selectedNodes)
  );
  const descendantSelected = !!children.find(
    child => child.state.selected || child.state.descendantSelected
  );
  const toggle = !!(toggleAncestors && descendantSelected);

  const readyNode = {
    ...node,
    state: {
      ...node.state,
      children,
      expanded: !!node.toggled || toggle,
      loaded: node.fetched !== false,
      selected,
      descendantSelected,
      hasMoreChildren: node.hasMoreChildren
    }
  };

  if (selected && selectedNodes) {
    selectedNodes.push(readyNode);
  }

  return readyNode;
};

export const getTreeForRenderAndSelectedNodes = (
  treeData,
  selectedNodesIds = [],
  toggleAncestors
) => {
  const selectedNodes = [];
  const nodes = treeData.map(node =>
    transformNode(node, selectedNodesIds, toggleAncestors, selectedNodes)
  );
  return { nodes, selectedNodes };
};

export const getTreeForRender = (treeData, selectedNodeId = null, toggleAncestors) => {
  return { nodes: treeData.map(node => transformNode(node, selectedNodeId, toggleAncestors)) };
};
